import gql from 'graphql-tag';

export default gql`
  query orderDraft($token: String!) {
    orderDraft(token: $token) {
      total
      orderDrafts {
        total
        paymentMethod
        deliveryNotes
        items {
          total
          note
          quantity
          deliveredNote
          buyerNote
          price
          orderedPrice
          product {
            supplierInternalCode
            id
            name
            imageUrl
            note
            vat
            uom
            uomLocal
            price
            allowPurchase
            inStock
            category {
              name
              parent {
                name
              }
            }
            tagImageVn
            tagImageEn
            priceV2 {
              price
              vat
              vatIncluded
            }
          }
        }
        supplier {
          fulfillmentTime {
            hoursToDelivery
            days
            cutoffTime
          }
          moq
          id
          name
          private
        }
        deliveryDatetime {
          start
          end
        }
        totalVat
        totalVatOnProducts
        subTotalBeforeVat
      }
      store {
        id
        freeShipping
        moq
      }
    }
  }
`;
